<template>
  <section class="invoice-add-wrapper">
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="invoiceData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching invoice data
      </h4>
      <div class="alert-body">
        No invoice found with this invoice id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-invoices-list'}"
        >
          Invoice List
        </b-link>
        for other invoices.
      </div>
    </b-alert>
    <b-row
      v-if="invoiceData"
      class="invoice-add"
    >

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-form @submit.prevent>
          <b-card
            no-body
            class="invoice-preview-card"
          >
            <!-- Header -->
            <b-card-body class="invoice-padding pb-0">

              <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

                <!-- Header: Left Content -->
                <div>
                  <div class="logo-wrapper">
                    <span class="brand-logo">
                      <b-img
                        :src="require(`@hw-ui/assets/images/logo/${this.$store.state.app.appConfig.logoName}`)"
                        style="width: 50px"
                        alt="logo"
                      />
                    </span>
                    <h3
                      class="invoice-logo"
                    >
                      {{ this.$store.state.app.appConfig.name }}
                    </h3>
                  </div>
                  <b-card-text class="mb-25">
                    {{ bankDetails.address.streetAddress }}
                  </b-card-text>
                  <b-card-text class="mb-25">
                    {{ bankDetails.address.postcode }} {{ bankDetails.address.city }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    {{ bankDetails.contact }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    Y-Tunnus: {{ bankDetails.YTunnus }}
                  </b-card-text>
                  <b-card-text class="mb-0">
                    ALV-Numero: {{ bankDetails.YTunnus }}
                  </b-card-text>
                </div>

                <!-- Header: Right Content -->
                <!-- Header: Right Content -->
                <div class="mt-md-2 mt-2">
                  <h4 class="invoice-title">
                    Laskuerittely
                  </h4>
                  <div class="invoice-date-wrapper">
                    <p
                      class="invoice-date-title"
                      style="width: 12rem"
                    >
                      Laskun päiväys:
                    </p>
                    <p class="invoice-date">
                      {{ invoiceData.date.toDate().toLocaleDateString('fi') }}
                    </p>
                  </div>
                  <div class="invoice-date-wrapper">
                    <p
                      class="invoice-date-title"
                      style="width: 12rem"
                    >
                      Toimituspäivämäärä:
                    </p>
                    <p class="invoice-date">
                      {{ invoiceData.date.toDate().toLocaleDateString('fi') }}
                    </p>
                  </div>
                  <div class="invoice-date-wrapper">
                    <p
                      class="invoice-date-title"
                      style="width: 12rem"
                    >
                      Eräpäivä:
                    </p>
                    <p class="invoice-date">
                      {{ invoiceData.dueDate.toDate().toLocaleDateString('fi') }}
                    </p>
                  </div>
                </div>
              </div>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing">

            <!-- Invoice Client & Payment Details -->
            <b-card-body
              class="invoice-padding pt-0"
            >
              <b-row class="invoice-spacing">

                <!-- Col: Invoice To -->
                <b-col
                  cols="12"
                  xl="6"
                  class="mb-lg-1"
                >
                  <h6 class="mb-2">
                    Vastaanottaja:
                  </h6>
                  <!-- Selected Client -->
                  <div
                    v-if="invoiceData.client"
                    class="mt-1"
                  >
                    <h6 class="mb-25">
                      {{ invoiceData.client.name }}
                    </h6>
                    <b-card-text class="mb-25">
                      {{ invoiceData.client.contact }}
                    </b-card-text>
                  </div>
                </b-col>

                <!-- Col: Payment Details -->
                <b-col
                  xl="6"
                  cols="12"
                  class="mt-xl-0 mt-2 justify-content-end d-xl-flex d-block"
                >
                  <!-- <div>
                    <h6
                      class="mb-2"
                      style="text-transform: uppercase"
                    >
                      Maksutiedot:
                    </h6>
                    <table>
                      <tbody>
                        <tr>
                          <td class="pr-1">
                            Nimi:
                          </td>
                          <td>{{ bankDetails.name }}</td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            IBAN:
                          </td>
                          <td>{{ bankDetails.IBAN }}</td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            BIC:
                          </td>
                          <td>{{ bankDetails.BIC }}</td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Viite #:
                          </td>
                          <td>{{ invoiceData.viiteNumero }}</td>
                        </tr>
                        <tr>
                          <td class="pr-1">
                            Pankki:
                          </td>
                          <td>{{ bankDetails.bankName }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> -->
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Items Section -->
            <b-card-body class="invoice-padding form-item-section">
              <div
                ref="form"
                class="repeater-form"
                :style="{height: trHeight}"
              >
                <b-row
                  v-for="(item, index) in invoiceData.items"
                  :key="index"
                  ref="row"
                  class="pb-2"
                >

                  <!-- Item Form -->
                  <!-- ? This will be in loop => So consider below markup for single item -->
                  <b-col cols="12">

                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-none d-lg-flex">
                      <b-row class="flex-grow-1 px-1">
                        <!-- Single Item Form Headers -->
                        <b-col
                          cols="12"
                          lg="4"
                        >
                          Työntekijä/Aika
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Määrä
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Yksikkö
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Hinta
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          Yhteensä
                        </b-col>
                      </b-row>
                      <div class="form-item-action-col" />
                    </div>

                    <!-- Form Input Fields OR content inside bordered area  -->
                    <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                    <div class="d-flex border rounded">
                      <b-row class="flex-grow-1 p-2">
                        <!-- Single Item Form Headers -->
                        <b-col
                          cols="12"
                          lg="4"
                        >
                          <label class="d-inline d-lg-none">Työntekijä/Aika</label>
                          <b-form-input
                            v-model="item.title"
                            type="text"
                            class="mb-2"
                          />
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Määrä</label>
                          <b-form-input
                            v-model="item.qty"
                            type="number"
                            class="mb-2"
                          />
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Yksikkö</label>
                          <b-form-input
                            v-model="item.unit"
                            type="text"
                            class="mb-2"
                          />
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Hinta</label>
                          <b-form-input
                            v-model="item.cost"
                            type="number"
                            class="mb-2"
                          />
                        </b-col>
                        <b-col
                          cols="12"
                          lg="2"
                        >
                          <label class="d-inline d-lg-none">Yhteensä</label>
                          <p class="mb-1">
                            {{ item.cost * item.qty }} €
                          </p>
                        </b-col>
                      </b-row>
                      <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                        <feather-icon
                          size="16"
                          icon="XIcon"
                          class="cursor-pointer"
                          @click="removeItem(index)"
                        />
                        <feather-icon
                          :id="`form-item-settings-icon-${index}`"
                          size="16"
                          icon="SettingsIcon"
                          class="cursor-pointer"
                        />

                        <!-- Setting Item Form -->
                        <b-popover
                          :ref="`form-item-settings-popover-${index}`"
                          :target="`form-item-settings-icon-${index}`"
                          triggers="click"
                          placement="lefttop"
                        >
                          <b-form @submit.prevent>
                            <b-row>

                              <!-- Field: Discount -->
                              <b-col cols="12">
                                <b-form-group
                                  label="Discount(%)"
                                  :label-for="`setting-item-${index}-discount`"
                                >
                                  <b-form-input
                                    :id="`setting-item-${index}-discount`"
                                    :value="null"
                                    type="number"
                                  />
                                </b-form-group>
                              </b-col>

                              <!-- Field: Tax 1 -->
                              <b-col cols="6">
                                <b-form-group
                                  label="Tax 1"
                                  :label-for="`setting-item-${index}-tax-1`"
                                >
                                  <v-select
                                    :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                                    :value="'10%'"
                                    :options="['0%', '1%', '10%', '14%', '18%']"
                                    :input-id="`setting-item-${index}-tax-1`"
                                    :clearable="false"
                                  />
                                </b-form-group>
                              </b-col>

                              <!-- Field: Tax 2 -->
                              <b-col cols="6">
                                <b-form-group
                                  label="Tax 2"
                                  :label-for="`setting-item-${index}-tax-2`"
                                >
                                  <v-select
                                    :dir="$store.state.hwUiLayout.isRTL ? 'rtl' : 'ltr'"
                                    :value="'10%'"
                                    :options="['0%', '1%', '10%', '14%', '18%']"
                                    :input-id="`setting-item-${index}-tax-2`"
                                    :clearable="false"
                                  />
                                </b-form-group>
                              </b-col>

                              <b-col
                                cols="12"
                                class="d-flex justify-content-between mt-1"
                              >
                                <b-button
                                  variant="outline-primary"
                                  @click="() => {$refs[`form-item-settings-popover-${index}`][0].$emit('close')}"
                                >
                                  Apply
                                </b-button>
                                <b-button
                                  variant="outline-secondary"
                                  @click="() => {$refs[`form-item-settings-popover-${index}`][0].$emit('close')}"
                                >
                                  Cancel
                                </b-button>
                              </b-col>
                            </b-row>
                          </b-form>
                        </b-popover>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                variant="primary"
                @click="addNewItemInItemForm"
              >
                Add Item
              </b-button>
            </b-card-body>

            <!-- Invoice Description: Total -->
            <b-card-body class="invoice-padding pb-0">
              <b-row>

                <!-- Col: Sales Persion -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-0 mt-3 d-flex align-items-center"
                  order="2"
                  order-md="1"
                />
                <!-- Col: Total -->
                <b-col
                  cols="12"
                  md="6"
                  class="mt-md-6 d-flex justify-content-end"
                  order="1"
                  order-md="2"
                >
                  <div class="invoice-total-wrapper">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Yhteensä veroton:
                      </p>
                      <p class="invoice-total-amount">
                        {{ invoiceTotal }}€
                      </p>
                    </div>
                    <hr class="my-50">
                    <div class="invoice-total-item">
                      <p class="invoice-total-title">
                        Yhteensä:
                      </p>
                      <p class="invoice-total-amount">
                        {{ invoiceTotal }}€
                      </p>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-card-body>

            <!-- Spacer -->
            <hr class="invoice-spacing">
          </b-card>
        </b-form>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions mt-md-0 mt-2"
      >

        <!-- Action Buttons -->
        <b-card>

          <!-- Button: Create Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            :disabled="!canSubmit"
            @click="onSubmit"
          >
            Save Changes
          </b-button>

          <!-- Button: Cancel -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            @click="onCancel"
          >
            Cancel
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <invoice-sidebar-add-new-customer />
  </section>
</template>

<script>
import { ref } from '@vue/composition-api'
import { heightTransition } from '@hw-ui/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import store from '@/shared/store'
// eslint-disable-next-line import/no-cycle
import router from '@/shared/router'
import { calculateShift } from '@/shared/services/invoice-calc'
import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'
import {
  BRow, BCol, BCard, BCardBody, BButton, BCardText, BForm, BFormGroup, BFormInput, BPopover, VBToggle,
  BImg, BAlert, BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import InvoiceSidebarAddNewCustomer from '../InvoiceSidebarAddNewCustomer.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BAlert,
    BLink,
    BFormGroup,
    BFormInput,
    BPopover,
    vSelect,
    BImg,
    InvoiceSidebarAddNewCustomer,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,

  },
  mixins: [heightTransition],
  computed: {
    canSubmit() {
      return this.invoiceTotal > 0 && this.invoiceData.client.id
    },
    invoiceTotal() {
      let total = 0
      this.invoiceData.items.forEach(item => {
        total += item.qty * item.cost
      })
      return total.toFixed(2)
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'invoiceData.items': function () {
      this.initTrHeight()
    },
  },
  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    onCancel() {
      this.$router.push({ name: 'apps-invoices-list' })
    },
    onSubmit() {
      const today = new Date()
      const dueDate = new Date(today)
      dueDate.setDate(dueDate.getDate() + 7)
      const { id } = this.invoiceData.client
      const total = this.invoiceTotal
      const items = this.invoiceData.items.map(item => ({ ...item, total: item.cost * item.qty }))
      store.dispatch('appInvoice/updateInvoice', {
        id,
        date: today,
        dueDate,
        total,
        items,
      })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('success'),
              text: 'Lasku päivitetty',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({ name: 'apps-invoices-list' })
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: this.$t('error'),
              text: this.$t('something_went_wrong'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
    getCost(requirements, contract, user) {
      if (!requirements) {
        return contract.price.default
      }
      if (user.love && contract.price.love) {
        return contract.price.love
      }
      return contract.price.default
    },
    fetchShifts(contractId, from, to) {
      store.dispatch('appInvoice/fetchInvoiceShifts', { contractId, from, to })
        .then(response => {
          this.invoiceData.items = []
          this.trSetHeight(null)
          response.data.forEach(shift => {
            const cost = this.getCost(shift.requirements, this.invoiceData.client, shift.user)
            const report = calculateShift(shift.start, shift.end, cost)
            let title = shift.title.split(':')[0]
            title = `${title.trim()} ${shift.start.toLocaleString('fi', { month: 'short', day: 'numeric' })}`
            const startTime = shift.start.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
            const endTime = shift.end.toLocaleString('fi', { hour: 'numeric', minute: 'numeric' })
            const shiftPeriod = `klo ${startTime} - ${endTime}`
            if (report.perus) {
              this.invoiceData.items.push({
                title: `${title} ${shiftPeriod}`,
                qty: report.perus.hours,
                unit: 'tuntia',
                cost,
              })
            }
            if (report.iltaLisa) {
              this.invoiceData.items.push({
                title: `${title} iltalisä`,
                qty: report.iltaLisa.hours,
                unit: 'tuntia',
                cost: cost * 0.15,
              })
            }
            if (report.yoLisa) {
              this.invoiceData.items.push({
                title: `${title} yölisä`,
                qty: report.yoLisa.hours,
                unit: 'tuntia',
                cost: cost * 0.30,
              })
            }
            if (report.lauantaiLisa) {
              this.invoiceData.items.push({
                title: `${title} lauantailisä`,
                qty: report.lauantaiLisa.hours,
                unit: 'tuntia',
                cost: cost * 0.25,
              })
            }
            if (report.sunnuntaiLisa) {
              this.invoiceData.items.push({
                title: `${title} sunnuntailisä`,
                qty: report.sunnuntaiLisa.hours,
                unit: 'tuntia',
                cost,
              })
            }
            if (report.ylityo) {
              if (report.ylityo.first) {
                this.invoiceData.items.push({
                  title: `${title} ylityö 50%`,
                  qty: report.ylityo.first.hours,
                  unit: 'tuntia',
                  cost: cost * 0.5,
                })
              }
              if (report.ylityo.second) {
                this.invoiceData.items.push({
                  title: `${title} ylityö 100%`,
                  qty: report.ylityo.second.hours,
                  unit: 'tuntia',
                  cost,
                })
              }
            }
            this.$nextTick(() => {
              this.trAddHeight(this.$refs.row[0].offsetHeight)
              setTimeout(() => {
                this.$refs.form.style.overflow = null
              }, 350)
            })
          })
        })
    },
    selectedContract(value) {
      if (value && (this.invoiceData.from < this.invoiceData.to)) {
        this.fetchShifts(value.id, this.invoiceData.from, this.invoiceData.to)
      }
    },
    setDate(date, slot) {
      /* eslint-disable no-param-reassign */
      if (slot === 'start') {
        [this.invoiceData.from] = date
      } else {
        [this.invoiceData.to] = date
      }
      if (this.invoiceData.client && (this.invoiceData.from < this.invoiceData.to)) {
        this.fetchShifts(this.invoiceData.client.id, this.invoiceData.from, this.invoiceData.to)
      }
      /* eslint-enable no-param-reassign */
    },
    addNewItemInItemForm() {
      this.$refs.form.style.overflow = 'hidden'
      this.invoiceData.items.push(JSON.parse(JSON.stringify(this.itemFormBlankItem)))

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        setTimeout(() => {
          this.$refs.form.style.overflow = null
        }, 350)
      })
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1)
      this.trTrimHeight(this.$refs.row[0].offsetHeight)
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form ? this.$refs.form.scrollHeight : 0)
      })
    },
  },
  setup() {
    const invoiceData = ref(null)
    store.dispatch('appInvoice/fetchInvoice', { id: router.currentRoute.params.id })
      .then(response => {
        invoiceData.value = response
      })
      .catch(error => {
        if (error.response.status === 404) {
          invoiceData.value = undefined
        }
      })
    const bankDetails = ref({ address: {} })
    store.dispatch('appInvoice/fetchBankDetails')
      .then(response => { bankDetails.value = response.data })

    const itemFormBlankItem = {
      item: null,
      cost: 0,
      qty: 0,
      unit: '',
    }
    return {
      invoiceData,
      bankDetails,
      itemFormBlankItem,
    }
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/vue-select.scss';
@import '@hw-ui/scss/vue/libs/vue-flatpicker.scss';
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
      color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@hw-ui/scss/base/pages/app-invoice.scss";
@import '~@hw-ui/scss/base/components/variables-dark';

.form-item-section {
background-color:$product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: .35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }

  }
}
</style>
